<div class="application-wrapper">
    <div class="logo">
        <img alt="Queens casino logo" priority ngSrc="images/queens-casino.svg" width="200" height="100">
    </div>
    <div class="application-content">
        <router-outlet />
    </div>
    @if (tabletIdentifier$ | async; as identifier) {
        <div class="identifier">
            <p appParagraph isFaded>{{ identifier }}</p>
            @if ((networkStatus$ | async) === false) {
                <mat-icon class="error-indicator">error</mat-icon>
            }
        </div>
    }
</div>

<div
    class="refresh-app"
    *ngIf="refreshingPageTime$ | async as refreshingPageTime"
>
    Pagina gaat herladen, in:
    {{ refreshingPageTime | timeLeft : false | async | lowercase }}.
</div>
